import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: []
}

export const orgRFQDataSlice = createSlice({
    name: 'orgRFQData',
    initialState,
    reducers: {
        setOrgRFQData: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { setOrgRFQData } = orgRFQDataSlice.actions;
export default orgRFQDataSlice.reducer;